import React from 'react';
import {PageLink, PageTitle} from "../../../_metronic/layout/core";
import {Navigate, Outlet, Route, Routes} from "react-router-dom";
import {PageListWrapper} from "./Post-List/PageList";
import PagePost from "./EditPost/PagePost";
const usersBreadcrumbs: Array<PageLink> = [
    {
        title: 'صفحه ها',
        path: '/apps/Page/List',
        isSeparator: false,
        isActive: false,
    },
    {
        title: '',
        path: '',
        isSeparator: true,
        isActive: false,
    },
]
const PagePage = () => {
    return (
        <Routes>
            <Route element={<Outlet />}>
                <Route
                    path='List'
                    element={
                        <>
                            <PageTitle breadcrumbs={usersBreadcrumbs}>مدیریت صفحه ها</PageTitle>
                            <PageListWrapper />
                        </>
                    }
                />
                <Route
                    path='edit/:id'
                    element={
                        <>
                            <PageTitle breadcrumbs={usersBreadcrumbs}>ویرایش صفحه</PageTitle>
                            <PagePost/>
                        </>
                    }
                />
                <Route
                    path='edit'
                    element={
                        <>
                            <PageTitle breadcrumbs={usersBreadcrumbs}> صفحه جدید</PageTitle>
                            <PagePost/>
                        </>
                    }
                />
            </Route>
            <Route index element={<Navigate to='/apps/Page/List' />} />
        </Routes>
    );
};

export default PagePage;